import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
// import ContactForm from "./ContactForm";
// import ClarityCalBrochurelInfo from "./ClarityCalBrochurelInfo";
import { Send, CheckCircle, 
  // Phone, Mail, MapPin,
   Loader2 } from "lucide-react";

export default function ProgramModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [hasShown, setHasShown] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const [showForm, setShowForm] = useState(true); 

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent));
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    // Check if modal has already been shown in this session
    // const modalShown = sessionStorage.getItem("programModalShown");
    const modalShown = false;

    if (!modalShown && !hasShown) {
      const timer = setTimeout(() => {
        setIsOpen(true);
        setHasShown(true);
        sessionStorage.setItem("programModalShown", "true");
      }, 8000); // 5 seconds delay

      return () => clearTimeout(timer);
    }
  }, [hasShown]);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simulate form submission

    console.log(formData);
    setIsSubmitting(true);
    // setShowForm(false);

    // setIsSubmitted(true);

    const formData1 = new URLSearchParams();
    formData1.append("name", formData.name);
    formData1.append("email", formData.email);
    formData1.append("phone", formData.phone);
    formData1.append("message", formData.message);

    setTimeout(() => {
      setIsSubmitted(true);
    }, 1000);

    fetch(
      "https://script.google.com/macros/s/AKfycbyt9TBIzsPSpyFr0dWMqqMV36s8gX6RjlJ9NYk9UXq2uamtRmsvt9bM351_tBCuESIfBQ/exec",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData1,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setIsSubmitted(true);
        console.log("Success:", data);
      })
      .catch((error) => {
        setIsSubmitted(false);
        // setShowForm(true);
        console.error("Fetch error:", error);
      });
  };

  return (
    <div className="p-8">
      {/* Optional Trigger Button - can be removed if not needed */}
      {/* Modal */}
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
            onClick={() => setIsOpen(false)}
          />

          {/* Modal Content */}
          <div className="relative bg-white rounded-2xl  shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden mx-4">
            {/* Close Button */}
            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-4 right-4 z-10 bg-white bg-opacity-90 hover:bg-opacity-100 rounded-full p-2 transition-all shadow-lg"
            >
              <X className="w-6 h-6 text-gray-600" />
            </button>

            {/* Modal Body */}
            <div className="flex  lg:flex-row h-full">
              {/* Image Section */}
              {!isMobile && (
                <div
                  className="lg:w-1/2 relative"
                  style={{
                    paddingLeft: "20px",
                    marginTop: "5px",
                    width: "max-content",
                  }}
                >
                  {/* <img
                  src="/images/1-1 free clarity call small.png"
                  alt="Program"
                  className="w-full h-64 lg:h-full object-cover"
                /> */}

                  <video
                    width="max-content"
                    height="auto"
                    autoPlay
                    muted
                    controls
                    loop
                    playsInline
                  >
                    <source src="/images/clarity.mp4" type="video/mp4" />
                  </video>

                  {/* <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" /> */}
                </div>
              )}

              {/* Content Section */}
              <div
                className="lg:w-1/2 pl-0 pr-0  flex flex-col justify-between overflow-y-auto"
                style={{
                  marginTop: "5px",
                  width: "max-content",
                }}
              >
                {/* <ClarityCalBrochurelInfo /> */}

                {isSubmitted && (
                  <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center bg-green-50 rounded-2xl p-12">
                      <CheckCircle className="h-16 w-16 text-green-600 mx-auto mb-6" />
                      <h2 className="text-3xl font-bold text-gray-900 mb-4">
                        Thank You!
                      </h2>
                      <p className="text-xl text-gray-600 mb-6">
                        Your message has been sent successfully. I'll get back
                        to you within 24 hours.
                      </p>
                      <div className="bg-white rounded-lg p-6 shadow-md">
                        <h3 className="text-lg font-semibold text-gray-900 mb-4">
                          What's Next?
                        </h3>
                        <ul className="text-left space-y-2 text-gray-600">
                          <li>• I'll review your message and goals</li>
                          <li>
                            • Schedule a complimentary 15-minute consultation
                          </li>
                          <li>• Discuss your coaching needs and options</li>
                          <li>• Create a personalized action plan</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
                {isSubmitted === false && (
                  <div className="max-w-7xl mx-auto px-4  ">
                    <div className="text-center mb-4">
                      <h2 className="text-4xl font-bold text-gray-900 mb-4">
                        Let's Start Your Journey
                      </h2>
                    </div>

                    <div>
                      <div>
                        <form onSubmit={handleSubmit} className="space-y-6">
                          <div>
                            <label
                              htmlFor="name"
                              className="block text-sm font-medium text-gray-700 mb-2"
                            >
                              Full Name *
                            </label>
                            <input
                              type="text"
                              id="name"
                              name="name"
                              value={formData.name}
                              onChange={handleInputChange}
                              required
                              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                              placeholder="Enter your full name"
                            />
                          </div>

                          <div>
                            <label
                              htmlFor="phone"
                              className="block text-sm font-medium text-gray-700 mb-2"
                            >
                              Phone Number *
                            </label>
                            <input
                              type="tel"
                              id="phone"
                              name="phone"
                              value={formData.phone}
                              onChange={handleInputChange}
                              required
                              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                              placeholder="9290000000"
                            />
                          </div>

                          <div>
                            <label
                              htmlFor="email"
                              className="block text-sm font-medium text-gray-700 mb-2"
                            >
                              Email Address
                            </label>
                            <input
                              type="email"
                              id="email"
                              name="email"
                              value={formData.email}
                              onChange={handleInputChange}
                              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                              placeholder="your@email.com"
                            />
                          </div>

                          <div>
                            <label
                              htmlFor="message"
                              className="block text-sm font-medium text-gray-700 mb-2"
                            >
                              Message
                            </label>
                            <textarea
                              id="message"
                              name="message"
                              value={formData.message}
                              onChange={handleInputChange}
                              rows={4}
                              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                              placeholder="Tell me about your goals and how I can help you..."
                            />
                          </div>

                          <button
                            type="submit"
                            className="w-full bg-purple-600 text-white py-4 px-6 rounded-lg font-semibold hover:bg-purple-700 transition-colors flex items-center justify-center"
                          >
                            Send Message
                            <Send className="ml-2 h-5 w-5" />
                          </button>
                        </form>
                      </div>

                      {isSubmitting && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                          <div className="bg-white rounded-lg p-8 max-w-sm w-full mx-4 text-center">
                            <Loader2 className="w-8 h-8 text-blue-500 animate-spin mx-auto mb-4" />
                            <p className="text-gray-700 font-medium">
                              Submitting your data...
                            </p>
                            <p className="text-gray-500 text-sm mt-2">
                              Please wait...
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
